import { OnboardingBusinessInfoDTO } from "@zenith/services/user";
import { SelectItemsType } from "@zenith/components/ui/SelectComponent/select-component/interfaces";

export const estimatedAnnualTurnoverItems: SelectItemsType[] = [
  {
    value: OnboardingBusinessInfoDTO.estimatedTurnover.LESS_THAN_5_MILLION,
    label: "Less than ₦5 million",
  },
  {
    value: OnboardingBusinessInfoDTO.estimatedTurnover.TURN_OVER_5M_TO_20M,
    label: "₦5 million - ₦20 million",
  },
  {
    value: OnboardingBusinessInfoDTO.estimatedTurnover.TURN_OVER_20M_TO_50M,
    label: "₦20 million - ₦50 million",
  },
  {
    value: OnboardingBusinessInfoDTO.estimatedTurnover.TURN_OVER_50M_TO_100M,
    label: "₦50 million - ₦100 million",
  },
  {
    value: OnboardingBusinessInfoDTO.estimatedTurnover.TURN_OVER_100M_TO_250M,
    label: "₦100 million - ₦250 million",
  },
  {
    value: OnboardingBusinessInfoDTO.estimatedTurnover.TURN_OVER_250M_TO_500M,
    label: "₦250 million - ₦500 million",
  },
  {
    value: OnboardingBusinessInfoDTO.estimatedTurnover.TURN_OVER_500M_TO_1B,
    label: "₦500 million - ₦1 billion",
  },
  {
    value: OnboardingBusinessInfoDTO.estimatedTurnover.MORE_THAN_1_BILLION,
    label: "More than ₦1 billion",
  },
];

export const staffSizeItems: SelectItemsType[] = [
  {
    value: OnboardingBusinessInfoDTO.staffStrength.JUST_ME_1,
    label: "Just me (1)",
  },
  {
    value: OnboardingBusinessInfoDTO.staffStrength.STAFF_2_5,
    label: "2 - 5 employees",
  },
  {
    value: OnboardingBusinessInfoDTO.staffStrength.STAFF_6_10,
    label: "6 - 10 employees",
  },
  {
    value: OnboardingBusinessInfoDTO.staffStrength.STAFF_11_20,
    label: "11 - 20 employees",
  },
  {
    value: OnboardingBusinessInfoDTO.staffStrength.STAFF_21_50,
    label: "21 - 50 employees",
  },
  {
    value: OnboardingBusinessInfoDTO.staffStrength.STAFF_51_100,
    label: "51 - 100 employees",
  },
  {
    value: OnboardingBusinessInfoDTO.staffStrength.STAFF_101_250,
    label: "101 - 250 employees",
  },
  {
    value: OnboardingBusinessInfoDTO.staffStrength.STAFF_251_PLUS,
    label: "251+ employees",
  },
];
